module.exports = __webpack_public_path__ + "static/media/AndraOrn.3acdbe81.png";